import { handleAuthorization, handleOkResponseJson } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterLocaisAsync,
	cadastrarLocalAsync,
	editarLocalAsync,
	downloadLista,
	buscarCepAsync
}

export const obterLocaisAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Locais/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const cadastrarLocalAsync = async (descricao, idTipoLocais, contratante, numeroDoLocal, cep, logradouro, numero, complemento, bairro, cidade, uf) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao, idTipoLocais, contratante, numeroDoLocal, cep, logradouro, numero, complemento, bairro, cidade, uf })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Locais`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const buscarCepAsync = async (cep) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() }
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Endereco/consultaCep/` + cep, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarLocalAsync = async (id, descricao, idTipoLocais, contratante, numeroDoLocal, cep, logradouro, numero, complemento, bairro, cidade, uf, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, idTipoLocais, contratante, numeroDoLocal, cep, logradouro, numero, complemento, bairro, cidade, uf, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Locais/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Locais/downloadLocais`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'locais' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}
